// extracted by mini-css-extract-plugin
module.exports = {"activationPopperRoot":"SubscriptionActions_activationPopperRoot__1ArGT"};